import { reversalEvents } from '@/mocks/home';

const sideMeta: Record<string, { dot: string; badge: string; label: string }> = {
  doubt: { dot: 'bg-accent-500', badge: 'bg-accent-100 text-accent-900', label: '质疑占优' },
  neutral: { dot: 'bg-secondary-500', badge: 'bg-secondary-100 text-secondary-900', label: '中立扩大' },
  support: { dot: 'bg-primary-500', badge: 'bg-primary-100 text-primary-800', label: '支持反超' },
};

export default function ReversalTimeline() {
  return (
    <section id="reversal" className="py-16 md:py-28">
      <div className="w-full px-4 md:px-10">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4 mb-12">
          <div>
            <span className="font-label text-xs tracking-[0.3em] text-primary-600">REVERSAL TRACK</span>
            <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mt-3">
              舆论反转时间轴
            </h2>
          </div>
          <p className="text-sm text-foreground-500 max-w-sm leading-relaxed">
            一次反转从来不是突然发生的。这条时间轴保留每一次态度变化的前因后果，也保留当时的站队比例。
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-4 gap-5 md:gap-4">
          {reversalEvents.map((event, index) => {
            const side = sideMeta[event.side] ?? sideMeta.neutral;
            return (
              <article key={event.stage} className="relative flex flex-col">
                <div className="flex items-center gap-3">
                  <span className={`w-3 h-3 rounded-full ${side.dot}`} />
                  <span className="font-heading text-sm font-bold text-foreground-950 tracking-wide">
                    {event.stage}
                  </span>
                  <span className="text-xs text-foreground-400 font-label">
                    0{index + 1}
                  </span>
                </div>
                <span className="hidden md:block h-px w-full bg-background-300/70 mt-3" />
                <div className="mt-4 md:mt-6 bg-background-100 border border-background-200/70 rounded-lg p-4 md:p-5 flex-1">
                  <span className="text-xs text-foreground-500 font-label">{event.time}</span>
                  <h3 className="font-heading text-base font-semibold text-foreground-950 mt-2 leading-snug">
                    {event.title}
                  </h3>
                  <p className="text-sm text-foreground-600 mt-3 leading-relaxed">{event.desc}</p>
                  <span className={`inline-block mt-4 px-2 py-0.5 rounded-full text-xs font-label ${side.badge}`}>
                    {side.label}
                  </span>
                </div>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
}